"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getHeaders = void 0;
var _checkoutUtils = require("@ori/checkout-utils");
var _constants = require("../constants");
const getHeaders = headersParams => {
  const {
    currentLanguage,
    isAddingSpecialHeadersForbidden,
    isApplicationNameAdded,
    tenant
  } = headersParams;
  return {
    [_checkoutUtils.ACCEPT_LANGUAGE]: currentLanguage,
    ...(!isAddingSpecialHeadersForbidden && {
      ...(tenant && {
        [_checkoutUtils.TENANT_CONTEXT]: tenant
      }),
      ...(isApplicationNameAdded && {
        [_checkoutUtils.CLIENT_APPLICATION]: _constants.APP_NAME
      })
    })
  };
};
exports.getHeaders = getHeaders;